// extracted by mini-css-extract-plugin
export default {"DeleteAccountSection":"DeleteAccountSection_DeleteAccountSection__LtNu+","TextContainer":"DeleteAccountSection_TextContainer__wemPo","SubText":"DeleteAccountSection_SubText__mVOKA"};